import React from 'react';
import classNames from 'classnames';

export interface LozengeProps {
  id?: string;
  className?: string;
  children?: React.ReactNode;
  maxWidth?: string;
  isContrast?: boolean;
  type?: 'default' | 'info' | 'moved' | 'new' | 'success';
  pill?: boolean;
}

const Lozenge: React.FC<LozengeProps> = (props: LozengeProps) => {
  const {
    id,
    className,
    children,
    maxWidth = '200px',
    isContrast = false,
    type = 'default',
    pill = false,
  } = props;

  const lozengeClass = classNames(
    className,
    'ui-lozenge',
    { 'ui-lozenge--pill': pill },
    `ui-lozenge_type-${type}${isContrast ? '--contrast' : ''}`
  );

  return (
    <span id={id} className={lozengeClass}>
      <span style={{ maxWidth }}>{children}</span>
    </span>
  );
};

export default Lozenge;
